import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {

    transform(value: any, args?: any[]): any[] {
        // create instance vars to store keys and final output
        let keyArr: any[] = Object.keys(value),
            dataArr = [];

        // loop through the object,
        // pushing values to the return array
        keyArr.forEach((key: any) => {
            console.log(key);
            dataArr.push(value[key]);
            console.log(value[key]);
        });
        console.log(keyArr);
        console.log(dataArr);

        // return the resulting array
        return dataArr;
    }

}
